import { render, staticRenderFns } from "./AffiliateCpaForm.vue?vue&type=template&id=58daa0dc&scoped=true&"
import script from "./AffiliateCpaForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateCpaForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCpaForm.vue?vue&type=style&index=0&id=58daa0dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58daa0dc",
  null
  
)

export default component.exports